function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useCurrentRefinements } from 'react-instantsearch';
import { Tag } from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_TEXT } from '../../config/constants';
import SearchReset from '../Reset';
import './style.scss';
const SearchActiveFacets = props => {
  const {
    t
  } = useTranslation();
  const {
    title,
    showEmptyState,
    emptyState = /*#__PURE__*/React.createElement("p", null, t(['searchkit.active_facets.empty_state', DEFAULT_TEXT.ACTIVE_FACETS.EMPTY_STATE])),
    className,
    showResetAll,
    resetAllProps,
    transformItems
  } = props;
  const {
    items,
    refine
  } = useCurrentRefinements({
    transformItems
  });
  const classNames = c('Searchkit__ActiveFacets', className);
  if (!showEmptyState && items.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames,
    "aria-live": "polite"
  }, (title || showResetAll) && /*#__PURE__*/React.createElement("div", {
    className: "Searchkit__ActiveFacets__header"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "Searchkit__ActiveFacets__title"
  }, /*#__PURE__*/React.createElement("h3", null, title)), showResetAll && /*#__PURE__*/React.createElement(SearchReset, _extends({}, resetAllProps, {
    resetSearch: false
  }))), showEmptyState && items.length === 0 ? emptyState : /*#__PURE__*/React.createElement("ul", {
    className: "Searchkit__ActiveFacets__facets"
  }, items.map(_ref => {
    let {
      attribute,
      label,
      refinements
    } = _ref;
    return /*#__PURE__*/React.createElement("li", {
      key: attribute
    }, /*#__PURE__*/React.createElement("div", {
      className: "Searchkit__ActiveFacets__facets__title"
    }, /*#__PURE__*/React.createElement("h4", null, label)), /*#__PURE__*/React.createElement("ul", {
      className: "Searchkit__ActiveFacets__facet-refinements"
    }, refinements.map(refinement => /*#__PURE__*/React.createElement("li", {
      key: "".concat(attribute, ":").concat(refinement.value)
    }, /*#__PURE__*/React.createElement(Tag, {
      name: refinement.label,
      onDelete: () => {
        refine(refinement);
      }
    })))));
  })));
};
SearchActiveFacets.defaultProps = {
  showEmptyState: false
};
export default SearchActiveFacets;